export const NAME_MIN_LENGTH = 3;
export const NAME_MAX_LENGTH = 18;

export const givenNameFromTemplate = (typeName = "") => typeName.replace(/&/g, "and").slice(0, NAME_MAX_LENGTH).trimEnd();

export const usernameRules = [
  { required: true, message: "Enter a username" },
  { min: NAME_MIN_LENGTH, max: NAME_MAX_LENGTH, message: "Username must contain between 3 and 18 characters" },
  { pattern: /^[a-zA-Z0-9]+$/, message: "Username can only contain letters and numbers" },
];

export const isValidGivenName = (value) => {
  const trimmed = value?.trim() ?? "";
  return trimmed.length >= NAME_MIN_LENGTH
    && trimmed.length <= NAME_MAX_LENGTH
    && /^[a-zA-Z0-9 ' -]+$/.test(trimmed);
};

export const givenNameRules = [
  { required: true, message: "Enter a name" },
  { min: NAME_MIN_LENGTH, max: NAME_MAX_LENGTH, message: "Name must contain between 3 and 18 characters" },
  { pattern: /^[a-zA-Z0-9 ' -]+$/, message: "Name can only contain letters, numbers, spaces, hyphens and apostrophes" },
];

export const GIVEN_NAME_REQUIREMENT = "Name must be 3-18 characters using letters, numbers, spaces, hyphens or apostrophes";
